module.exports = __webpack_public_path__ + "img/mobile-img-th.f2297739.png";